import React from "react";
import "./custom-button.scss";

export default function CustomButton({name, classnames, onClick, disabled}) {
  return (
    <button onClick={onClick} className={`button ${disabled ? 'disabled' : classnames}`}>
      <strong>{name}</strong>
    </button>
  );
}
